// lingland-frontend/src/components/layout/Header.js
import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import logoImage from '../../assets/images/logo-lingland.png';
import { Menu, X, Upload } from 'lucide-react';
import './Header.css';

function Header() {
  const { t } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const handleLinkClick = () => { if (isMobileMenuOpen) setIsMobileMenuOpen(false); };

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isMobileMenuOpen]);

  return (
    <header className={`app-header sticky ${isMobileMenuOpen ? 'mobile-menu-is-open' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <Link to="/" onClick={handleLinkClick}>
            <img src={logoImage} alt="Lingland Logo" className="logo-img" />
          </Link>
        </div>

        <nav className="main-nav desktop-nav">
          <ul>
            <li><NavLink to="/" end onClick={handleLinkClick}>{t('nav_home')}</NavLink></li>
            <li><NavLink to="/uslugi" onClick={handleLinkClick}>{t('nav_services')}</NavLink></li>
            <li><NavLink to="/cennik" onClick={handleLinkClick}>{t('nav_pricing')}</NavLink></li>
            <li><NavLink to="/jak-to-dziala" onClick={handleLinkClick}>{t('nav_how_it_works')}</NavLink></li>
            <li><NavLink to="/o-nas" onClick={handleLinkClick}>{t('nav_about_us')}</NavLink></li>
            <li><NavLink to="/blog" onClick={handleLinkClick}>{t('nav_blog')}</NavLink></li>
            <li><NavLink to="/kontakt" onClick={handleLinkClick}>{t('nav_contact')}</NavLink></li>
          </ul>
        </nav>        <div className="header-cta desktop-cta">
          <Link to="/wycena" className="button-outline-primary header-button" onClick={handleLinkClick}>
            {t('nav_get_quote')}
          </Link>
          <LanguageSwitcher />
        </div>

        {/* Mobile controls - language switcher + hamburger */}
        <div className="mobile-controls">
          <div className="mobile-language-switcher">
            <LanguageSwitcher />
          </div>
          <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu" aria-expanded={isMobileMenuOpen}>
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        <div className={`mobile-menu-panel ${isMobileMenuOpen ? 'is-open' : ''}`}>
          <nav className="mobile-nav">
            <ul>
              <li><NavLink to="/" end onClick={handleLinkClick}>{t('nav_home')}</NavLink></li>
              <li><NavLink to="/uslugi" onClick={handleLinkClick}>{t('nav_services')}</NavLink></li>
              <li><NavLink to="/cennik" onClick={handleLinkClick}>{t('nav_pricing')}</NavLink></li>
              <li><NavLink to="/jak-to-dziala" onClick={handleLinkClick}>{t('nav_how_it_works')}</NavLink></li>
              <li><NavLink to="/o-nas" onClick={handleLinkClick}>{t('nav_about_us')}</NavLink></li>
              <li><NavLink to="/blog" onClick={handleLinkClick}>{t('nav_blog')}</NavLink></li>
              <li><NavLink to="/kontakt" onClick={handleLinkClick}>{t('nav_contact')}</NavLink></li>
            </ul>
          </nav>          <div className="mobile-menu-cta">
            <Link to="/wycena" className="button-primary mobile-cta-button" onClick={handleLinkClick}>
              <Upload size={18} style={{ marginRight: '0.5rem' }}/> {t('nav_get_quote')}
            </Link>
          </div>
        </div>
        {isMobileMenuOpen && <div className="mobile-menu-overlay" onClick={toggleMobileMenu}></div>}
      </div>
    </header>
  );
}
export default Header;